import React from 'react';
import { useInView } from 'react-intersection-observer';
import { ReactComponent as HandshakeIcon } from '../../assets/svg/handshake.svg';
import { ReactComponent as ExperimentIcon } from '../../assets/svg/experiment.svg';
import { ReactComponent as NodeIcon } from '../../assets/svg/node.svg';
import { ReactComponent as GaugeIcon } from '../../assets/svg/gauge.svg';
import '../../styles/landing/stats.css';

const Stats = () => {
	const { ref: statsRef, inView: statsVisible } = useInView({
		triggerOnce: true,
		threshold: 0.7,
	});

	return (
		<div ref={statsRef} className="landing-stats">
			<section className='landing-stats-title'>
				<GaugeIcon className={`icon gauge-svg ${statsVisible ? 'animate' : ''}`}/>
				<h1>How ProMS is making a difference</h1>
			</section>

			<div className="goals">
				<div className={`goal ${statsVisible ? 'goal-animate' : ''}`} style={{animationDelay: '0s'}}>
					<NodeIcon className="icon" />
					<h1>3</h1>
					<p>National Research Nodes</p>
				</div>
				<div className={`goal ${statsVisible ? 'goal-animate' : ''}`} style={{animationDelay: '0.2s'}}>
					<ExperimentIcon className="icon" />
					<h1>2</h1>
					<p>Clinical Trials on Cancer Diagnostics</p>
				</div>
				<div className={`goal ${statsVisible ? 'goal-animate' : ''}`} style={{animationDelay: '0.4s'}}>
					<HandshakeIcon className="icon" />
					<h1>10+</h1>
					<p>Global Collaborations</p>
				</div>
			</div>
		</div>
	);
};

export default Stats;
